<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import List from '../../extend/List.vue';
import JobCardOptimized from '../../components/JobCardOptimized.vue';
@Component()
export default class WillOptimizedResume extends Vue.extend(List) {
  options = {
    url: "/portal/delivery/optimization",
    methods: "GET"
  }
  componentName = JobCardOptimized
}
</script>